import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { usePromocode } from '~/hooks/usePromocode';

import { cartStore } from '~/stores';

import Icon from '../../Icon/Icon';

import styles from './Promocode.module.scss';

interface PromocodeVariant1Props {
  disabled?: boolean | null;
}

const Promocode = observer(({ disabled }: PromocodeVariant1Props) => {
  const { t } = useTranslation();

  const {
    promocodeVal,
    warningMsg,
    handlePromocodeChange,
    handleDelPromocode,
    handleSubmit,
  } = usePromocode();

  return (
    <form
      className={classes(['promocode__form', styles.root])}
      onSubmit={handleSubmit}
    >
      <div
        className={classes([
          'promocode__form-control',
          styles.promocode__formControl,
          promocodeVal.length &&
            cartStore.promocode.success === null &&
            styles._filled,
          cartStore.promocode.errorType === 'error' && styles._error,
          (cartStore.promocode.errorType === 'warning' || warningMsg) &&
            styles._warning,
          cartStore.promocode.success === true &&
            !warningMsg &&
            styles._success,
        ])}
      >
        <div
          className={classes([
            'checkout-summary__promocode-content',
            styles.checkoutSummary__promocodeContent,
            styles.promocodeContent,
          ])}
        >
          {cartStore.promocode.success === true && (
            <Icon
              type="check-circled"
              size={24}
              className={styles.successIcon}
            />
          )}
          <input
            className={classes([styles.input])}
            placeholder={t('phrases:enterPromocode')}
            value={promocodeVal}
            onChange={handlePromocodeChange}
            disabled={Boolean(disabled)}
          />
          {promocodeVal &&
            promocodeVal !== cartStore.promocode.value &&
            company.promocodeInInputResetCheckout && (
              <button
                className={classes([
                  'button',
                  '_no-padding',
                  '_no-color',
                  'button-icon',
                  styles.buttonIcon,
                ])}
                onClick={handleDelPromocode}
                type="button"
                disabled={Boolean(disabled)}
              >
                <Icon type="burger-close" size={24} className={styles.icon} />
              </button>
            )}
          {cartStore.promocode.success !== null &&
          promocodeVal === cartStore.promocode.value ? (
            <button
              className={classes(['button', styles.button, styles.remove])}
              type="submit"
              onClick={handleDelPromocode}
              disabled={Boolean(disabled)}
            >
              {t('remove')}
            </button>
          ) : (
            promocodeVal && (
              <button
                className={classes(['button', styles.button, styles.accept])}
                type="submit"
              >
                {t('accept')}
              </button>
            )
          )}
        </div>
        {cartStore.promocode.message && (
          <p
            className={classes([
              'promocode__form-control-result',
              styles.promocode__formControlResult,
            ])}
          >
            {cartStore.promocode.message}
          </p>
        )}
      </div>
      {warningMsg && (
        <div className={classes(['alert _warning mt-16 z-1', styles.alert])}>
          {warningMsg}
        </div>
      )}
    </form>
  );
});

export default Promocode;
